
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/serie/[seriesId]",
      function () {
        return require("private-next-pages/serie/[seriesId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/serie/[seriesId]"])
      });
    }
  